import React, { useEffect, useState } from "react";
import Icon1 from "../icons/Icon";

const TFGPT1 = ({
  inputValue,
  setInputValue,
  options = [],
  placeholder,
  onAction,
  width = 400,
  start_only = true,
  visible_empty = false,
  show_options = true,
}) => {
  useEffect(() => {
    if (
      visible_empty &&
      (inputValue === "" ||
        inputValue === " " ||
        inputValue === undefined ||
        inputValue === null)
    ) {
      setFilteredOptions(options);
    }

    if (inputValue === "" || inputValue === " ") {
      resetSearch();
    }
  }, [options, visible_empty, inputValue]);

  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);
    // Filter options based on the input
    if (value) {
      let filtered = [];

      filtered = options.filter((option) =>
        option.label?.toLowerCase().includes(value.toLowerCase())
      );

      let sorted = filtered.sort((a, b) => a.label.localeCompare(b.label));
      setFilteredOptions(sorted);
      setIsDropdownVisible(true);
    } else {
      setFilteredOptions([]);
      setIsDropdownVisible(false);
    }
  };

  const resetSearch = () => {
    if (visible_empty) {
      setFilteredOptions(options);
      setIsDropdownVisible(true);
    } else {
      setInputValue("");
      setFilteredOptions([]);
      setIsDropdownVisible(false);
      setInputValue("");
      let option = { label: "" };
      onAction(option);
    }
  };

  const handleOptionClick = (e, option) => {
    e.stopPropagation();
    setInputValue(option.label);
    onAction(option);
    setIsDropdownVisible(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // Trigger onAction with current inputValue
      setIsDropdownVisible(false);
      if (!show_options) {
        onAction("enter");
      }
    }
  };

  const handleBlur = () => {
    // Hide the dropdown when the input loses focus
    setTimeout(() => setIsDropdownVisible(false), 100);
  };

  return (
    <div
      className="w-full  h-full flex flex-row gap-2  select-none"
      style={{
        width: width,
      }}
    >
      <input
        type="text"
        value={inputValue}
        onFocus={() => visible_empty && setIsDropdownVisible(true)}
        onBlur={() => {
          // Delay closing the dropdown to allow click events on it to register
          setTimeout(() => setIsDropdownVisible(false), 150);
        }}
        onKeyDown={handleKeyDown}
        onChange={handleInputChange}
        placeholder={placeholder}
        className="w-full px-4 py-1  rounded-lg focus:outline-none focus:border-2 focus:outline-1 focus:outline-blue-100 focus:border-blue-300 text-h3"
      />
      {isDropdownVisible && show_options && filteredOptions.length > 0 && (
        <ul className="absolute z-20 w-fit min-w-c300 mt-8 bg-white border border-gray-300 rounded-lg shadow-lg max-h-c300  overflow-y-auto">
          {filteredOptions
            .sort((a, b) => a.label.trim().localeCompare(b.label.trim()))
            .map((option, index) => (
              <li
                key={index}
                onClick={(e) => handleOptionClick(e, option)}
                className="px-4 py-2 cursor-pointer hover:bg-blue-100 flex flex-row gap-2"
              >
                <div className="text-h3"> {option.label}</div>
                {option.extra_label && (
                  <span
                    className={` ${option.client_type ? (option.client_type === "particulier" ? "text-purple-400 bg-purple-50" : option.client_type === "constructor" ? "text-indigo-400 bg-indigo-50" : "text-blue-400 bg-blue-50") : "text-blue-400 bg-blue-50"}  font-light  rounded-full px-1 text-h4 ml-1`}
                  >
                    {option.extra_label}
                  </span>
                )}
                {option.extra_label_2 && (
                  <span
                    className={`  text-teal-300 bg-teal-50 font-light  rounded-full px-1 text-h4 ml-1`}
                  >
                    {option.extra_label_2}
                  </span>
                )}
              </li>
            ))}
        </ul>
      )}
      <div
        className="flex cursor-pointer min-h-full items-center justify-center  "
        onClick={resetSearch}
      >
        <Icon1
          icon_name="close"
          fill={inputValue === "" ? "grey" : "red"}
          size={20}
          hover_color={"black"}
        ></Icon1>
      </div>
    </div>
  );
};

export default TFGPT1;
